export default "__VITE_ASSET__CY9nHxq1__"